import request from '../utils/request';

// 创建运费地区规则
export const createFreightTemplateRule = (data) => {
  return request({
    url: '/freight-template-rule/create',
    method: 'post',
    data
  });
};

// 更新运费地区规则
export const updateFreightTemplateRule = (data) => {
  return request({
    url: '/freight-template-rule/update',
    method: 'put',
    data
  });
};

// 删除运费地区规则
export const deleteFreightTemplateRule = (id) => {
  return request({
    url: `/freight-template-rule/delete/${id}`,
    method: 'delete'
  });
};

// 获取运费模板的地区规则列表
export const getFreightTemplateRuleList = (templateUid) => {
  return request({
    url: `/freight-template-rule/list-by-template-uid/${templateUid}`,
    method: 'get'
  });
};
